module.exports = __webpack_public_path__ + "img/09.cdd1117b.jpg";